import { FunctionComponent, memo } from 'react';
import { StoryCardType } from '../../../../../../services';
import { IconLabel } from '../../../../IconLabel';

import classes from './StoryCardMediaPlaceholder.module.scss';

interface StoryCardMediaPlaceholderProps {
  url: string;
  type: StoryCardType;
}

export const StoryCardMediaPlaceholder: FunctionComponent<StoryCardMediaPlaceholderProps> = memo(
  ({ url, type }) => {
    return (
      <a href={url} className={classes['placeholder']} target={'_blank'} rel={'noreferrer'}>
        <IconLabel
          iconId={type.toLowerCase()}
          className={classes['placeholder__icon']}
          iconSize={32}
          color={'#fff'}
          singleColor
        />
      </a>
    );
  }
);
